import { render } from "./newMemberReport.vue?vue&type=template&id=4492fc48"
import script from "./newMemberReport.vue?vue&type=script&lang=js"
export * from "./newMemberReport.vue?vue&type=script&lang=js"

import "./newMemberReport.vue?vue&type=style&index=0&id=4492fc48&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__